/* personalization.js – Improved version with better field recognition */
console.log('[personalization] loaded');

(function () {
  var YES_TEXT = 'tak';
  var NO_TEXT  = 'nie';
  var CACHE_KEY = '__pers_initials_v2';

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { var list = (root || document).querySelectorAll(sel); return Array.prototype.slice.call(list); }
  function norm(t) { return (t || '').toString().trim().toLowerCase(); }
  function getProductRoot() { return qs('#MainContent') || document.body; }

  // ——— Cache ————————————————————————————————————————————————
  function getCachedInitials() {
    try { var v = localStorage.getItem(CACHE_KEY); if (v) { window.__pers_cache__ = v; return v; } } catch (e) {}
    return window.__pers_cache__ || '';
  }
  function setCachedInitials(val) {
    var v = val || '';
    window.__pers_cache__ = v;
    try { localStorage.setItem(CACHE_KEY, v); } catch (e) {}
  }

  // ——— Formularze ————————————————————————————————————————————————
  function getProductForms() {
    var found = [];
    function pushUnique(el) { if (el && found.indexOf(el) === -1) found.push(el); }

    var selectors = ['product-form form', 'shopify-product-form form', 'form[action^="/cart/add"]'];
    for (var s = 0; s < selectors.length; s++) {
      var els = qsa(selectors[s]);
      for (var i = 0; i < els.length; i++) pushUnique(els[i]);
    }

    var forms = qsa('form');
    for (var m = 0; m < forms.length; m++) {
      if (forms[m].querySelector('input[name="id"], select[name="id"]')) pushUnique(forms[m]);
    }
    return found;
  }

  // ——— Rozpoznawanie "Personalizacja" (z wszelkimi wariantami) ————————————————————————————
  function normalizeOptionName(str) {
    // Normalizes "Personalizacja +35 zł" → "personalizacja"
    var n = norm(str);
    return n.split(/[\s+]/)[0]; // weź tylko pierwszy wyraz
  }

  function findPersonalizationContainer(root) {
    root = root || getProductRoot();

    // 1) Szukaj po atrybutach (możliwa nazwa bez ceny)
    var attrSelectors = [
      '[data-option-name*="Personalizacja"]',
      '[data-name*="Personalizacja"]',
      '[data-option*="Personalizacja"]',
      '[aria-label*="Personalizacja"]'
    ].join(',');
    var byAttr = qs(attrSelectors, root);
    if (byAttr) return byAttr;

    // 2) Szukaj po legend/label (dokładnie lub prefix)
    var blocks = qsa('fieldset, .product-form__input, .product__option, section, div', root);
    for (var i = 0; i < blocks.length; i++) {
      var head = qs('legend, .form__label, .product-form__input-title, h2, h3, h4, label', blocks[i]);
      if (head) {
        var headNorm = normalizeOptionName(head.textContent);
        if (headNorm === 'personalizacja') return blocks[i];
      }
    }

    // 3) Szukaj po zawartości "tak" i "nie"
    var cands = qsa('fieldset, .product-form__input, .product__option, [role="radiogroup"], div, section', root);
    for (var j = 0; j < cands.length; j++) {
      var txt = (cands[j].textContent || '').toLowerCase();
      if (/\bnie\b/.test(txt) && /\btak\b/.test(txt)) return cands[j];
    }
    return null;
  }

  // ——— Odczyt wartości opcji "Personalizacja" (wszędzie) ————————————————————————
  function readPersonalizationAnywhere() {
    // a) Radio z name^="Personalizacja"
    var radiosX = qsa('input[type="radio"]');
    for (var x = 0; x < radiosX.length; x++) {
      var name = radiosX[x].getAttribute('name') || '';
      if (name.toLowerCase().indexOf('personalizacja') !== -1 && radiosX[x].checked) {
        var valX = radiosX[x].getAttribute('aria-label') || radiosX[x].value || '';
        return norm(valX);
      }
    }

    // b) Selecty – klasyczne OS2.0 fallback
    var selects = qsa('select');
    for (var s = 0; s < selects.length; s++) {
      var selectName = (selects[s].getAttribute('name') || '').toLowerCase();
      if (selectName.indexOf('personalizacja') !== -1) {
        return norm(selects[s].value);
      }
    }

    return null;
  }

  // ——— Filtr/format inicjałów ————————————————————————————————
  var POLISH_LETTER_RE = /[A-Za-zĄąĆćĘęŁłŃńÓóŚśŹźŻż]/g;

  function extractLetters(str) {
    var arr = (str || '').match(POLISH_LETTER_RE) || [];
    for (var i = 0; i < arr.length; i++) arr[i] = arr[i].toUpperCase();
    return arr.slice(0, 3);
  }

  function formatWithDots(lettersArr) {
    if (!lettersArr || !lettersArr.length) return '';
    return lettersArr.join('.') + '.';
  }

  function setCaretToEnd(el) {
    try { var len = (el.value || '').length; el.setSelectionRange(len, len); } catch (e) {}
  }

  // ——— UI: widoczne pole ———————————————————————————————
  function injectPlaceholderStyle() {
    if (document.getElementById('pers-placeholder-style')) return;
    var style = document.createElement('style');
    style.id = 'pers-placeholder-style';
    style.type = 'text/css';
    style.textContent =
      '#initials-input::placeholder{color:#9ca3af;opacity:1;text-transform:none;}' +
      '#initials-input::-webkit-input-placeholder{color:#9ca3af;text-transform:none;}' +
      '#initials-input::-moz-placeholder{color:#9ca3af;text-transform:none;}' +
      '#initials-input:-ms-input-placeholder{color:#9ca3af;text-transform:none;}';
    document.head.appendChild(style);
  }

  function createVisibleField() {
    var wrap = document.createElement('div');
    wrap.id = 'personalization-wrapper';
    wrap.style.display = 'none';
    wrap.style.marginTop = '18px';
    wrap.style.clear = 'both';
    wrap.style.gridColumn = '1 / -1';
    wrap.style.width = '100%';
    wrap.style.position = 'relative';

    var input = document.createElement('input');
    input.id = 'initials-input';
    input.type = 'text';
    input.maxLength = 6;
    input.autocomplete = 'off';
    input.placeholder = 'Inicjały';
    input.setAttribute('aria-label', 'Inicjały (max 3 litery)');
    input.style.width = '100%';
    input.style.border = '1px solid #e5e7eb';
    input.style.borderRadius = '12px';
    input.style.padding = '12px 14px';
    input.style.fontSize = '16px';
    input.style.boxSizing = 'border-box';
    input.style.outline = 'none';

    injectPlaceholderStyle();

    input.addEventListener('input', function (e) {
      var letters = extractLetters(e.target.value);
      var formatted = formatWithDots(letters);
      if (e.target.value !== formatted) {
        e.target.value = formatted;
        setCaretToEnd(e.target);
      }
      setCachedInitials(e.target.value);
      syncHiddenToForms();
      setFlagForForms(letters.length > 0);
    });

    input.addEventListener('keydown', function (e) {
      var key = e.key || '';
      var code = e.keyCode || 0;

      if (key === '.' || code === 190 || code === 110) {
        e.preventDefault();
        return;
      }

      if (key === 'Backspace' || code === 8) {
        e.preventDefault();
        var letters = extractLetters(e.target.value);
        if (letters.length) letters.pop();
        e.target.value = formatWithDots(letters);
        setCaretToEnd(e.target);
        setCachedInitials(e.target.value);
        syncHiddenToForms();
        setFlagForForms(letters.length > 0);
        return;
      }

      if (key === 'Delete' || code === 46) {
        setTimeout(function(){
          var letters = extractLetters(input.value);
          input.value = formatWithDots(letters);
          setCaretToEnd(input);
          setCachedInitials(input.value);
          syncHiddenToForms();
          setFlagForForms(letters.length > 0);
        }, 0);
        return;
      }
    });

    var cached = getCachedInitials();
    if (cached) {
      input.value = cached;
      setCaretToEnd(input);
      setTimeout(function(){
        syncHiddenToForms();
        setFlagForForms(extractLetters(input.value).length > 0);
      }, 0);
    }

    wrap.appendChild(input);
    return { wrap: wrap, input: input };
  }

  function ensureVisibleFieldPlaced() {
    var root = getProductRoot();
    var container = findPersonalizationContainer(root);
    if (!container) return null;

    var existing = document.getElementById('personalization-wrapper');
    if (existing) {
      return { wrap: existing, input: existing.querySelector('#initials-input') };
    }

    var ui = createVisibleField();

    if (container.parentNode) {
      if (container.nextSibling) {
        container.parentNode.insertBefore(ui.wrap, container.nextSibling);
      } else {
        container.parentNode.appendChild(ui.wrap);
      }
    } else {
      document.body.appendChild(ui.wrap);
    }

    var cached = getCachedInitials();
    if (cached) {
      var inp = ui.input;
      if (inp) inp.value = cached;
      syncHiddenToForms();
      setFlagForForms(extractLetters(cached).length > 0);
    }

    console.log('[personalization] visible field placed');
    return ui;
  }

  // ——— Hiddeny ————————————————————————————————————————————————
  function ensureHiddenFieldsInForms() {
    var forms = getProductForms();
    for (var i = 0; i < forms.length; i++) {
      var hiddenFlag = forms[i].querySelector('input[name="properties[Personalizacja]"]');
      if (!hiddenFlag) {
        hiddenFlag = document.createElement('input');
        hiddenFlag.type = 'hidden';
        hiddenFlag.name = 'properties[Personalizacja]';
        forms[i].appendChild(hiddenFlag);
      }
      var hiddenInit = forms[i].querySelector('input[name="properties[Inicjały]"]');
      if (!hiddenInit) {
        hiddenInit = document.createElement('input');
        hiddenInit.type = 'hidden';
        hiddenInit.name = 'properties[Inicjały]';
        hiddenInit.value = getCachedInitials();
        forms[i].appendChild(hiddenInit);
      }
    }
  }

  function syncHiddenToForms() {
    var forms = getProductForms();
    var visible = document.getElementById('initials-input');
    var val = visible ? (visible.value || '') : getCachedInitials();
    for (var i = 0; i < forms.length; i++) {
      var hiddenInit = forms[i].querySelector('input[name="properties[Inicjały]"]');
      if (hiddenInit) hiddenInit.value = val;
    }
  }

  function setFlagForForms(yes) {
    var forms = getProductForms();
    for (var i = 0; i < forms.length; i++) {
      var hiddenFlag = forms[i].querySelector('input[name="properties[Personalizacja]"]');
      if (hiddenFlag) hiddenFlag.value = yes ? 'Tak' : 'Nie';
      if (!yes) {
        var hiddenInit = forms[i].querySelector('input[name="properties[Inicjały]"]');
        if (hiddenInit) hiddenInit.value = '';
      }
    }
  }

  // ——— Pokazywanie/ukrywanie pola ————————
  function toggle(show) {
    var ui = ensureVisibleFieldPlaced();
    ensureHiddenFieldsInForms();
    if (!ui) return;

    var current = ui.wrap.style.display !== 'none';
    var desired = (show === undefined || show === null) ? current : !!show;

    ui.wrap.style.display = desired ? 'block' : 'none';
    var cached = getCachedInitials();
    if (ui.input && cached && ui.input.value !== cached) ui.input.value = cached;
    syncHiddenToForms();
    setFlagForForms(extractLetters(ui.input ? ui.input.value : '').length > 0);
  }

  // ——— Odczyt i zmiana widoczności ————————————————————————————————
  function readAndToggle() {
    var any = readPersonalizationAnywhere();
    if (any === YES_TEXT) { toggle(true); return; }
    if (any === NO_TEXT)  { toggle(false); return; }
  }

  // ——— Zdarzenia ————————————————————————————————————————————————
  function clickHandler(e) {
    var container = findPersonalizationContainer(getProductRoot());
    if (!container || !container.contains(e.target)) return;
    setTimeout(readAndToggle, 0);
  }

  function onSubmitValidate(e) {
    var wrap = document.getElementById('personalization-wrapper');
    var visible = wrap && wrap.style.display !== 'none';
    var inp = document.getElementById('initials-input');
    var letters = inp ? extractLetters(inp.value) : [];

    if (visible) {
      if (!inp || !letters.length) {
        e.preventDefault();
        alert('Wpisz inicjały (1–3 litery), aby dodać produkt z personalizacją.');
        if (inp && inp.focus) inp.focus();
        return;
      }
      inp.value = formatWithDots(letters);
      setCachedInitials(inp.value);
      syncHiddenToForms();
      setFlagForForms(true);
    } else {
      setFlagForForms(false);
    }
  }

  function bind() {
    if (window.__pers_bound__) return;
    window.__pers_bound__ = true;

    document.addEventListener('click', clickHandler, true);
    document.addEventListener('change', function () { setTimeout(readAndToggle, 0); }, true);
    document.addEventListener('variant:changed', function(){
      setTimeout(function(){
        ensureVisibleFieldPlaced();
        syncHiddenToForms();
        setFlagForForms(extractLetters(getCachedInitials()).length > 0);
      }, 0);
      readAndToggle();
    }, true);

    var obs = new MutationObserver(function () {
      ensureVisibleFieldPlaced();
      syncHiddenToForms();
      setFlagForForms(extractLetters(getCachedInitials()).length > 0);
      readAndToggle();
    });
    obs.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-checked','aria-pressed','aria-selected','data-selected','data-value','checked']
    });

    if (!window.__pers_poll__) {
      window.__pers_poll__ = setInterval(function(){
        ensureVisibleFieldPlaced();
        syncHiddenToForms();
        setFlagForForms(extractLetters(getCachedInitials()).length > 0);
        readAndToggle();
      }, 400);
    }

    var forms = getProductForms();
    if (!forms.length) {
      document.addEventListener('submit', onSubmitValidate, true);
    } else {
      for (var i = 0; i < forms.length; i++) {
        forms[i].addEventListener('submit', onSubmitValidate, true);
      }
    }

    console.log('[personalization] events bound');
  }

  // ——— Init ————————————————————————————————————————————————
  function init(retries) {
    if (typeof retries === 'undefined') retries = 80;
    var forms = getProductForms();
    var container = findPersonalizationContainer(getProductRoot());
    if (!forms.length || !container) {
      if (retries > 0) { setTimeout(function(){ init(retries - 1); }, 100); }
      else { console.log('[personalization] timeout – form or container not found'); }
      return;
    }
    ensureVisibleFieldPlaced();
    ensureHiddenFieldsInForms();

    var cached = getCachedInitials();
    if (cached) {
      var inp = qs('#initials-input');
      if (inp) inp.value = cached;
      syncHiddenToForms();
      setFlagForForms(extractLetters(cached).length > 0);
    }

    bind();
    readAndToggle();
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  window.addEventListener('pageshow', init);
  document.addEventListener('shopify:section:load', init);
})();